/**
 * Global Imports
*/

import React from 'react';
import { Route, Switch } from 'react-router-dom';

/**
 * Local Imports
*/

import { GuestForms } from '../../Auth';

/**
 * Exports
*/

/**
 * 
 */
export function GuestRouter(props) {
  return (
    <Switch>
      <Route path='/' component={ GuestForms } />
    </Switch>
  );
}